import { FundType } from '../constants';

const FUND_TYPE_ORDER = new Map([
  [FundType.CORE, 0],
  [FundType.FOCUSED, 1],
  [FundType.FOLLOW_ON, 2],
  [FundType.SYNDICATION, 3],
]);

const getFundTypeOrder = (fundType) => {
  const order = FUND_TYPE_ORDER.get(fundType);
  if (order === undefined) {
    throw new Error(`Unsupported venture plan fund type: ${fundType}`);
  }
  return order;
};

const normalizePlan = (plan) => {
  if (!plan?.fundTypeAllocations) {
    return plan;
  }
  if (!Array.isArray(plan.fundTypeAllocations)) {
    throw new TypeError('Venture plan fund allocations must be an array');
  }

  return {
    ...plan,
    fundTypeAllocations: plan.fundTypeAllocations
      .map((allocation) => ({
        allocation,
        order: getFundTypeOrder(allocation.fundType),
      }))
      .sort((left, right) => left.order - right.order)
      .map(({ allocation }) => allocation),
  };
};

export default normalizePlan;
